import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { servicesData } from '../data/services';

const servicesOptions = [
  ...servicesData.map(s => s.title),
  'Other'
];

const testimonials = [
  { name: 'Gina', text: 'Hamsa is my go to for my readings. She is not only accurate but she is compassionate, patient & understanding. It is like talking to your best friend. Her light work helps tremendously and quickly. Her crystals and candles are magical. She prepared a bottle with a crystal for me and it truly works like magic! Highly recommended! You will not be disappointed!', icon: '✨' },
  { name: 'Leo', text: 'Hamsa has changed my life. I was in a really dark place and randomly found Ivana scrolling through TikTok live. Watched for about 20 minutes, decided to get a reading. My mind was BLOWN AWAY on how accurate the reading was. So much so I lost sleep because I couldn\'t fathom how someone could know so much about my situation but not even know me. I\'ve done privates and just keeping in touch with Hamsa has made me want to live again. My mood changed drastically since I\'ve had the pleasure of meeting her. She will forever be apart of my life now. If you have any doubt she can help you. Don\'t. She is amazing and the truth.', icon: '🌟' },
  { name: 'Christopher', text: 'Hamsa knows the answers before I even ask the questions, she is a real psychic', icon: '🔮' },
  { name: 'Nestor', text: 'If you\'re thinking about getting a reading don\'t look any further. I\'ve traveled the world and can say that my experience with Ivana was by far the best reading that I\'ve ever had. Without giving her any information to work off of she knew my past and after the reading gave me a sense of reassurance. Would highly Recommend her.', icon: '🌙' }
];

function HomePage() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [formData, setFormData] = useState({ name: '', phone: '', email: '', service: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.slice(1));
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  useEffect(() => {
    const interval = setInterval(() => setCurrentTestimonial(prev => (prev + 1) % testimonials.length), 5000);
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');
    try {
      await emailjs.send('service_o818uv4', 'template_49knbx5', {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        service: formData.service,
        message: formData.message,
        to_email: 'hamsastarot@gmail.com',
        subject: 'New Inquiry - Hamsa\'s Tarot'
      }, 'fRUIq5Bj63ow-e2yg');
      setSubmitStatus('success');
      setFormData({ name: '', phone: '', email: '', service: '', message: '' });
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main>
      <section id="home" className="hero">
        <div className="hero-bg">
          <div className="mystical-symbols">
            <div className="symbol">✨</div>
            <div className="symbol">🌙</div>
            <div className="symbol">⭐</div>
            <div className="symbol">🔮</div>
            <div className="symbol">🌟</div>
            <div className="symbol">✨</div>
          </div>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-line">Welcome to the</span>
              <span className="title-line highlight">Sacred Realm</span>
            </h1>
            <p className="hero-subtitle">Journey with a divine messenger, bridging worlds through ancient wisdom and celestial guidance</p>
            <div className="hero-buttons">
              <button className="cta-button primary" onClick={() => scrollToSection('services')}>Explore Services</button>
              <button className="cta-button secondary" onClick={() => scrollToSection('contact')}>Connect Now</button>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About the Sacred Journey</h2>
            <div className="section-ornament"><span>✧</span><span>◆</span><span>✧</span></div>
          </div>
          <div className="about-content">
            <div className="about-text">
              <p className="intro-text">Greetings, kindred spirit. I am a soul called forth from the ancient shadows and shimmering light, a vessel of divine purpose.</p>
              <p>As a psychic, clairvoyant, medium, light worker, and healer, I walk between worlds — bridging the realms of the living and the spirits, channeling sacred knowledge from the cosmic depths.</p>
              <p>Since the age of seven, I have been attuned to the whispers of the universe, the gentle guidance of ethereal beings, and the profound wisdom that flows through the veil between dimensions.</p>
              <p>I am honored to be one of the sacred 24 "Free Will Watchers" — guardians chosen to protect the delicate balance of choice and destiny that governs our mortal realm.</p>
              <p>Through sacred vows to the divine pantheon, I have pledged my existence to guiding souls toward their highest potential, illuminating the path to enlightenment and spiritual awakening.</p>
            </div>
            <div className="about-visual">
              <div className="owner-photo-container">
                <div className="mystical-circle">
                  <div className="circle-content">
                    <div className="photo-frame">
                      <img src="/owner.jpg" alt="Hamsa - Spiritual Guide and Healer" className="owner-photo" onError={(e) => { e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUwIiBoZWlnaHQ9IjI1MCIgdmlld0JveD0iMCAwIDI1MCAyNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTI1IiBjeT0iMTI1IiByPSIxMjUiIGZpbGw9InVybCgjZ3JhZGllbnQwX3JhZGlhbF8xXzEpIi8+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudDBfcmFkaWFsXzFfMSIgeDE9IjEyNSIgeTE9IjAiIHgyPSIxMjUiIHkyPSIyNTAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjZjRlNGJjIiBzdG9wLW9wYWNpdHk9IjAuMyIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzJkMWI2OSIgc3RvcC1vcGFjaXR5PSIwLjYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48dGV4dCB4PSIxMjUiIHk9IjEzNSIgZm9udC1mYW1pbHk9IkNpbnplbCIgZm9udC1zaXplPSI0OCIgZmlsbD0iI2Y0ZTRiYyIgdGV4dC1hbmNob3I9Im1pZGRsZSI+8J+qvzwvdGV4dD48L3N2Zz4='; }} />
                      <div className="photo-overlay"></div>
                    </div>
                  </div>
                </div>
                <div className="circling-symbols">
                  <div className="symbol-orbit">
                    <span className="orbit-symbol symbol-1">🌙</span>
                    <span className="orbit-symbol symbol-2">⭐</span>
                    <span className="orbit-symbol symbol-3">🔮</span>
                    <span className="orbit-symbol symbol-4">✨</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Sacred Services</h2>
            <div className="section-ornament"><span>✧</span><span>◆</span><span>✧</span></div>
          </div>
          <div className="services-grid">
            {servicesData.map((service) => (
              <Link key={service.slug} to={`/services/${service.slug}`} className="service-card service-card-link">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.shortDesc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section id="pricing" className="pricing">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Sacred Pricing</h2>
            <div className="section-ornament"><span>✧</span><span>◆</span><span>✧</span></div>
          </div>
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-icon">🌀</div>
              <h3>Single Chakras Alignment</h3>
              <div className="pricing-amount">$125 <span className="pricing-unit">p/h</span></div>
              <p className="pricing-desc">Focused alignment for one energy center per session.</p>
            </div>
            <div className="pricing-card">
              <div className="pricing-icon">✨</div>
              <h3>7 Chakras Alignment</h3>
              <div className="pricing-amount">$150 <span className="pricing-unit">p/h</span></div>
              <ul className="pricing-details">
                <li>2 hrs — 10% off</li>
                <li>3 hrs — 15% off</li>
              </ul>
              <p className="pricing-note">Hourly and session amount may vary upon how many chakras can be covered. Breaks may be required depending on how both the chakras patient and I respond to the work.</p>
            </div>
            <div className="pricing-card">
              <div className="pricing-icon">🌙</div>
              <h3>7 Chakras + Aura Healing — Half Sessions</h3>
              <div className="pricing-options">
                <div className="pricing-option"><strong>A)</strong> 1–3 sessions, 1 hr — <span className="price">$250</span><br /><span className="option-detail">(1–3 chakras p/s). Total 3 hours.</span></div>
                <div className="pricing-option"><strong>B)</strong> 1–3 sessions p/m — <span className="price">$550</span><br /><span className="option-detail">Total 6 hr. Estimated 2–6 sessions (4–7 chakras p/s).</span></div>
              </div>
              <p className="pricing-note">Session length may vary depending on how both the chakras patient and I respond to the work.</p>
            </div>
            <div className="pricing-card">
              <div className="pricing-icon">🌟</div>
              <h3>7 Chakras + Aura Healing — Full Sessions</h3>
              <div className="pricing-options">
                <div className="pricing-option"><strong>A)</strong> 1–3 sessions, 1–3 hr — <span className="price">$550</span><br /><span className="option-detail">(7 chakras p/s). Total 3 hours.</span></div>
                <div className="pricing-option"><strong>B)</strong> 2–6 sessions p/m — <span className="price">$1,050</span><br /><span className="option-detail">Total 6 hr. Estimated 2–6 sessions (7 chakras p/s).</span></div>
              </div>
              <p className="pricing-note">Session amounts may vary. Some sessions require breaks due to energy overwhelm.</p>
            </div>
            <div className="pricing-card pricing-card-featured">
              <div className="pricing-icon">💫</div>
              <h3>Monthly Boost</h3>
              <p className="pricing-availability">Available after 7 Chakras has been aligned/healed by vibrational healing sessions.</p>
              <div className="pricing-options">
                <div className="pricing-option"><strong>A)</strong> 20 min — quick 7 alignment/healing/energy boost — <span className="price">$350</span></div>
                <div className="pricing-option"><strong>B)</strong> 45 min — quick 7 alignment/healing/energy boost — <span className="price">$350</span></div>
                <div className="pricing-option"><strong>C)</strong> Single Chakra — <span className="price">$125</span></div>
              </div>
              <p className="pricing-note">Unlocked after the 7 chakras have been covered by the hourly sessions.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="testimonials" className="testimonials">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Sacred Testimonials</h2>
            <div className="section-ornament"><span>✧</span><span>◆</span><span>✧</span></div>
          </div>
          <div className="testimonials-slider">
            <div className="slider-container">
              <button className="slider-nav prev" onClick={() => setCurrentTestimonial(prev => (prev - 1 + testimonials.length) % testimonials.length)}><span>‹</span></button>
              <div className="testimonial-slide">
                <div className="testimonial-card active">
                  <div className="testimonial-icon">{testimonials[currentTestimonial].icon}</div>
                  <div className="testimonial-content">
                    <p className="testimonial-text">"{testimonials[currentTestimonial].text}"</p>
                    <h3 className="testimonial-name">- {testimonials[currentTestimonial].name}</h3>
                  </div>
                </div>
              </div>
              <button className="slider-nav next" onClick={() => setCurrentTestimonial(prev => (prev + 1) % testimonials.length)}><span>›</span></button>
            </div>
            <div className="slider-dots">
              {testimonials.map((_, index) => (
                <button key={index} className={`dot ${index === currentTestimonial ? 'active' : ''}`} onClick={() => setCurrentTestimonial(index)}><span></span></button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="contact">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Sacred Connection</h2>
            <div className="section-ornament"><span>✧</span><span>◆</span><span>✧</span></div>
          </div>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-card">
                <div className="contact-icon">📞</div>
                <h3>Sacred Hotline</h3>
                <a href="tel:+17255770910" className="contact-detail">+1 (725) 577-0910</a>
                <a href="tel:+17029274345" className="contact-detail contact-detail-link">+1 (702) 927-4345</a>
              </div>
              <div className="contact-card">
                <div className="contact-icon">📧</div>
                <h3>Divine Messages</h3>
                <a href="mailto:hamsastarot@gmail.com" className="contact-detail">hamsastarot@gmail.com</a>
                <p className="contact-sub">Reach out for guidance</p>
              </div>
              <div className="contact-card">
                <div className="contact-icon">🌐</div>
                <h3>Community Portal</h3>
                <a href="https://www.facebook.com/share/18vMkJREEK/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer" className="contact-detail">Facebook Community</a>
                <p className="contact-sub">Join our sacred circle</p>
              </div>
            </div>
            <div className="contact-form-section">
              <h3 className="form-title">Send Your Sacred Inquiry</h3>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-grid">
                  <div className="form-group"><input type="text" name="name" value={formData.name} onChange={handleInputChange} placeholder="Your Sacred Name" required className="form-input" /></div>
                  <div className="form-group"><input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Your Phone Number" required className="form-input" /></div>
                  <div className="form-group"><input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="Your Email Address" required className="form-input" /></div>
                  <div className="form-group">
                    <select name="service" value={formData.service} onChange={handleInputChange} required className="form-select">
                      <option value="">Select Your Desired Service</option>
                      {servicesOptions.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
                    </select>
                  </div>
                </div>
                <div className="form-group full-width"><textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Share your sacred message or questions..." rows="4" required className="form-textarea" /></div>
                <button type="submit" disabled={isSubmitting} className={`form-submit ${isSubmitting ? 'submitting' : ''}`}>{isSubmitting ? <span><div className="spinner"></div>Sending Sacred Message...</span> : 'Send Sacred Message'}</button>
                {submitStatus === 'success' && <div className="form-message success">✨ Your sacred message has been sent! I will respond to your inquiry soon.</div>}
                {submitStatus === 'error' && <div className="form-message error">🌙 There was an issue sending your message. Please try again or contact me directly.</div>}
              </form>
            </div>
          </div>
        </div>
      </section>

      <section id="legal" className="legal">
        <div className="container">
          <div className="legal-content">
            <h3>Legal Disclaimer</h3>
            <p><strong>Hamsa's Tarot</strong> - Services provided are for entertainment purposes only. Must be 18+ to use services. By using our services, you acknowledge that spiritual guidance is not a substitute for professional medical, legal, or financial advice. We are not responsible for any decisions made based on the information provided during readings. All readings are based on spiritual intuition and should be used for personal growth and entertainment.</p>
          </div>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
